import React from "react";
import SearchService from "../../services/SearchService";
import "./SearchHistory.css";

/**
 * SearchHistory Component
 * Componente para exibir histórico de pesquisas
 * @version 1.0.0
 */

const SearchHistory = ({ history, onClearHistory, onSearch }) => {
  if (!history || history.length === 0) {
    return (
      <div className="search-history">
        <div className="empty-history">
          <p>📭 Seu histórico de pesquisas está vazio</p>
          <p className="hint">Comece digitando na barra de pesquisa</p>
        </div>
      </div>
    );
  }

  // Agrupar histórico por datas
  const groupByDate = () => {
    const grouped = {};

    history.forEach((item) => {
      const date = new Date(item.createdAt).toLocaleDateString("pt-BR");
      if (!grouped[date]) {
        grouped[date] = [];
      }
      grouped[date].push(item);
    });

    return grouped;
  };

  const groupedHistory = groupByDate();

  return (
    <div className="search-history">
      <div className="history-header">
        <h2>⏱️ Histórico de Pesquisas</h2>
        <button
          onClick={onClearHistory}
          className="btn-clear-history"
          title="Limpar todo o histórico"
        >
          🗑️ Limpar Histórico
        </button>
      </div>

      <div className="history-groups">
        {Object.entries(groupedHistory).map(([date, items]) => (
          <div key={date} className="history-group">
            <h3 className="group-date">📅 {date}</h3>

            <div className="history-items">
              {items.map((item) => (
                <HistoryItem
                  key={item._id}
                  item={item}
                  onSearch={onSearch}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

/**
 * Componente para um item do histórico
 */
const HistoryItem = ({ item, onSearch }) => {
  const handleClick = () => {
    onSearch(item.query);
  };

  // Ícone para o tipo de resultado
  const getResultIcon = () => {
    if (item.resultTypes && item.resultTypes.length > 0) {
      const type = item.resultTypes[0];
      switch (type) {
        case "exercise":
          return "💪";
        case "user":
          return "👤";
        case "blog":
          return "📝";
        case "lookbook":
          return "👗";
        case "movie":
          return "🎬";
        case "podcast":
          return "🎙️";
        default:
          return "📌";
      }
    }
    return "🔍";
  };

  // Tempo relativo
  const getTimeAgo = (date) => {
    return SearchService.getTimeAgo(new Date(date));
  };

  return (
    <div className="history-item">
      <div className="item-left">
        <span className="item-icon">{getResultIcon()}</span>
        <div className="item-info">
          <p className="item-query">{item.query}</p>
          <p className="item-meta">
            {item.totalResults} resultado{item.totalResults !== 1 ? "s" : ""} •{" "}
            {getTimeAgo(item.createdAt)}
          </p>
          {item.resultTypes && item.resultTypes.length > 0 && (
            <div className="item-types">
              {item.resultTypes.map((type) => (
                <span key={type} className="type-badge">
                  {type}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="item-actions">
        <button
          onClick={handleClick}
          className="btn-search-again"
          title="Repetir busca"
        >
          🔁 Buscar
        </button>
      </div>
    </div>
  );
};

export default SearchHistory;
